import { jsx as _jsx } from "react/jsx-runtime";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { useRetrieveSeason } from "../api/SeasonApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
export const useLeagueSeasonGuard = ({ leagueId, seasonId, }) => {
    const { data: permissions, isLoading: permissionsLoading, error: permissionsError, } = useRetrieveUserLeaguePermissions({ leagueId });
    const canModify = permissions?.canModify === true;
    const { data: season, isLoading: seasonLoading, error: seasonError, } = useRetrieveSeason({ id: seasonId, enabled: canModify });
    if (permissionsLoading)
        return { status: "loading" };
    if (permissionsError)
        return { status: "error", error: permissionsError };
    if (!canModify)
        return { status: "forbidden" };
    if (seasonLoading)
        return { status: "loading" };
    if (seasonError || !season)
        return { status: "error", error: seasonError };
    return { status: "ready", season };
};
export const LeagueSeasonGuardFallback = ({ guard }) => {
    if (guard.status === "forbidden")
        return _jsx(Forbidden, {});
    if (guard.status === "error")
        return _jsx(ErrorView, { error: guard.error });
    return _jsx(Loading, {});
};
